import { saveToken, loadToken, saveOpenId, loadOpenId, removeToken } from '@/utils/cache'
import router from '@/router'
import qs from 'qs'
import store from '@/store'
import wechatAuth from '@/plugins/wechatAuth'
import utils from '@/utils/util'
import apiHomePage from "@/api/home-page/index"
import apiUserPage from "@/api/user-page/index"
import { Notify } from "vant"

let wConfig = utils.getConfig()
// 设置APPID
wechatAuth.setAppId(wConfig.VUE_APP_WECHAT_APPID)
wechatAuth.setCropId(wConfig.VUE_APP_WXWORK_APPID)
wechatAuth.setAgent(wConfig.VUE_APP_WXWORK_AGENTID)


const whiteList = ['/404', '/result/pay_suc','/result/pay_suc_qrcode','/result/pay_suc_qrcode_2','/qrcode-pay','/qrcode-pay-2', '/to-pay-2',
'/register','/anonymous-pay','/anonymous-pay-detail','/pay-confirm','/add-account']
router.beforeEach(async (to, from, next) => {

    if (!utils.isWeChatBrowser()) {
        return next()
    }

    //在白名单，直接进入
    if (whiteList.indexOf(to.path) !== -1) {
        return next()
    }
    // await store.dispatch('mars/user/setLoginStatus', 0)
    const { loginStatus } = store.getters

    console.log('loginStatus--------' + loginStatus)
    console.log('loadToken--------' + loadToken())
    console.log('loadOpenId--------' + loadOpenId())
    switch (Number(loginStatus)) {
        /*
          loginStatus == 0; 表示未授权未绑定用户
        */
        case 0:
            // 设置回调地址，本地和线上不同
            wechatAuth.redirect_uri = processUrl()
            await store.dispatch('mars/user/setLoginStatus', 1)
            // 请求授权登录，跳转完整的授权地址
            if(utils.isWorkWeChatBrowser()){
                window.location.href = wechatAuth.wxWorkauthUrl
            }else{
                window.location.href = wechatAuth.authUrl
            }
            break
        /*
          loginStatus == 1; 表示已授权未获取到openId
        */
        case 1:
            try {
                console.log('1--------' + window.location.href)
                wechatAuth.returnFromWechat(window.location.href)
                const code = wechatAuth.code
                if(utils.isWorkWeChatBrowser()){
                    apiHomePage.getTokenByCode({ wxCode: code }, { customHandleError: true })
                        .then(res => {
                            let data = res.data || {}
                            let token = data.token
                            let openId = data.openId
                            store.commit('mars/user/SET_TOKEN', saveToken(token))
                            // next('/')
                            next('/home')
                        })
                        .catch(err => {
                            console.log('getToken方法报错---------', err)
                            if (err.code === 5001) {
                                if (to.path === '/login') {
                                    next()
                                } else {
                                    next('/login')
                                }
                            } else {
                                Notify({
                                    type: "danger",
                                    message: err.message
                                })
                            }
                        })
                }else{
                    await store.dispatch('mars/user/getOpenId', code)
                }
                await store.dispatch('mars/user/setLoginStatus', 2)
                // hash
                if (process.env.NODE_ENV !== 'development' && router.mode === 'hash') {
                    window.location.href = window.location.origin + window.location.pathname + window.location.hash
                } else {
                    console.log('to.fullPath----1' + to.fullPath)
                    // 由于需要绑定用户，所以不能直接next()
                    console.log('token---------', loadToken())
                    next('/login')
                    // next()
                }
            } catch (err) {
                // 获取openId失败重新跳转授权
                await store.dispatch('mars/user/setLoginStatus', 0)
                next('/')
            }
            break

        /*
          loginStatus == 2; 表示已授权已获取到openId
        */
        case 2:
            console.log('to.fullPath----2' + to.fullPath + "|" + loadToken())
            // debugger
            // 由于需要绑定用户，所以不能直接next()
            if(utils.isWorkWeChatBrowser()){
                next('/home')
            }
            if (utils.isNotEmpty(loadToken())) {
                // 检查token是否失效
                apiUserPage.checkToken({ }, { customHandleError: true })
                    .then(res => {
                       ;
                    })
                    .catch(err => {
                        apiHomePage.getToken({ openId: loadOpenId() }, { customHandleError: true })
                        .then(res => {
                            let data = res.data || {}
                            let token = data.token
                            store.commit('mars/user/SET_TOKEN', saveToken(token))
                            // next('/')
                            next('/home')
                        })
                        .catch(err => {
                            console.log('getToken方法报错---------', err)
                            if (err.code === 5001) {
                                if (to.path === '/login') {
                                    next()
                                } else {
                                    next('/login')
                                }
                            } else {
                                Notify({
                                    type: "danger",
                                    message: err.message
                                })
                            }
                        })
                })

                if (to.path === '/login') { // 绑定用户之后，直接进入主页
                    // next('/')
                    console.log("to home")
                    next('/home')
                } else {
                    console.log("to next")
                    next()
                }
            } else {
                // if(to.path === '/login') {
                // 	next()
                // } else {
                // 	next('/login')
                // }

                // 不能直接跳绑定页面，先要调用getToken方法 （20200721）
                apiHomePage.getToken({ openId: loadOpenId() }, { customHandleError: true })
                    .then(res => {
                        let data = res.data || {}
                        let token = data.token
                        store.commit('mars/user/SET_TOKEN', saveToken(token))
                        // next('/')
                        next('/home')
                    })
                    .catch(err => {
                        console.log('getToken方法报错---------', err)
                        if (err.code === 5001) {
                            if (to.path === '/login') {
                                next()
                            } else {
                                next('/login')
                            }
                        } else {
                            Notify({
                                type: "danger",
                                message: err.message
                            })
                        }
                    })
            }
            break
        default:
            break
    }
})

/**
 * 处理url链接
 * @returns {string}
 */
function processUrl() {
    // 本地环境换通过auth.html拿code
    if (process.env.NODE_ENV === 'development') {
        // 中间授权页地址
        return `${wConfig.VUE_APP_WECHAT_AUTH_URL}?backUrl=${window.location.href}`
    }
    const url = window.location.href
    // 解决多次登录url添加重复的code与state问题
    const urlParams = qs.parse(url.split('?')[1])
    let redirectUrl = url
    if (urlParams.code && urlParams.state) {
        delete urlParams.code
        delete urlParams.state
        const query = qs.stringify(urlParams)
        if (query.length) {
            redirectUrl = `${url.split('?')[0]}?${query}`
        } else {
            redirectUrl = `${url.split('?')[0]}`
        }
    }
    return redirectUrl
}
